import { TransactionResp } from "@/types/transaction.type";
import { ColumnDef } from "@tanstack/react-table";
import moment from "moment-timezone";
import { useTranslation } from "react-i18next";
import Tooltip from "@/components/Tooltip";
import { TypeTransaction } from "@/constants/enum";
import { useNavigate } from "react-router-dom";

export default function TableHeader(): ColumnDef<TransactionResp>[] {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleViewImage = (row: TransactionResp) => {
    row.images.forEach((item) => {
        window.open(item.image_url, '_blank');
    })
  }

  return [
    {
      id: "business_unit_name",
      header: t("transaction.business_unit"),
      accessorKey: "business_unit_name",
      enableSorting: false,
    },
    {
      id: "transaction_type_name",
      header: t("transaction.category"),
      accessorKey: "transaction_type_name",
      enableSorting: false,
    },
    {
      header: t("transaction.date"),
      accessorKey: "date",
      cell: ({ row }) => row.original.date ? moment(row.original.date).format("MMM DD YYYY") : "",
      enableSorting: false,
    },
    {
      header: t("form.description"),
      accessorKey: "description",
      enableSorting: false,
    },
    {
      id: "unit_code_code",
      header: t("transaction.transaction_code"),
      accessorKey: "unit_code_code",
      enableSorting: false,
      cell: ({ row }) => (
        <>
          <p>{row.original.unit_code_code}</p>
          <small>{row.original.unit_code_name}</small>
        </>
      ),
    },
    {
      header: t("transaction.deposit"),
      accessorKey: "amount_deposit",
      enableSorting: false,
      cell: ({ row }) => {
        return (
          row.original.amount_deposit > 0 && (
            <span className="text-meta-3">
              {row.original.amount_deposit.toLocaleString('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 2})}
            </span>
          )
        );
      },
    },
    {
      header: t("transaction.withdraw"),
      accessorKey: "amount_withdraw",
      enableSorting: false,
      cell: ({ row }) => {
        return (
          row.original.amount_withdraw > 0 && (
            <span className="text-red">
              {row.original.amount_withdraw.toLocaleString('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 2})}
            </span>
          )
        );
      },
    },
    {
      header: t("table.action"),
      accessorKey: "action",
      enableSorting: false,
      meta: {
        className: "w-10 min-w-10 text-center",
      },
      cell: ({ row }) => {
        return <div className="flex justify-center cursor-pointer">
          {
            row.original.images ?
                <button className="hover:text-warning" type="button" onClick={() => navigate(location , {state: {modal: "/transactions/image", images: row.original.images.map((item) => item.image_url)}})}>
                  <i className="fa-sharp fa-light fa-eye" />
                </button>
                :
                (
                    row.original.type === TypeTransaction.WITHDRAW &&  <Tooltip text={t("transaction.missing_document")}>
                        <i className="fa-solid fa-circle-exclamation text-red-700"></i>
                    </Tooltip>
                )
          }
        </div>
      }
    }
  ];
}
